module.exports = __webpack_public_path__ + "static/media/IKMS02.b1e5474f.jpg";